interface MultiplierProps {
  isCompleted: boolean;
  hasX?: boolean;
  maxMultiplier: number;
  multiplier: number | undefined;
}

const Multiplier: React.FC<MultiplierProps> = ({ isCompleted, hasX = true, maxMultiplier, multiplier }: MultiplierProps) => {
  if (maxMultiplier === 0 || maxMultiplier === 1) {
    return null;
  }

  const multiplierRenderValue = isCompleted ? multiplier : 0;
  const xRenderValue = hasX ? 'x' : '';
  const displayValue =
    maxMultiplier === 0 ? `${xRenderValue}${multiplierRenderValue}` : `${xRenderValue}${multiplierRenderValue}/${maxMultiplier}`;

  return <span className='text-sm text-blue-100'>{displayValue}</span>;
};

export default Multiplier;
